import React from 'react'
import Link from 'gatsby-link'

//Components
import SelectLanguage from '../components/SelectLanguage.js'

const PostFooter = props => {
  return (
    <nav className="main-nav">
      {props.langs.map(lang => {
        if (lang.langKey == 'en' && lang.selected) {
          return (
            <React.Fragment key={lang.langKey}>
              <div key={lang.langKey} className="container post-footer">
                Budget Offices in Central America:{' '}
                <a href="https://budget.com.gt/" target="_blank">Nicaragua</a> |{' '}
                <a href="http://www.budget.com.hn/" target="_blank">Honduras</a> |{' '}
                <a href="http://www.budget.com.sv/" target="_blank">El Salvador</a> |{' '}
                <a href=" https://www.budget.co.cr/" target="_blank">Costa Rica</a>
              </div>
            </React.Fragment>
          )
        } else if (lang.langKey == 'es' && lang.selected) {
          return (
            <React.Fragment key={lang.langKey}>
              <div key={lang.langKey} className="container post-footer">
                Budget Offices in Central America:{' '}
                <a href="https://budget.com.gt/" target="_blank">Nicaragua</a> |{' '}
                <a href="http://www.budget.com.hn/" target="_blank">Honduras</a> |{' '}
                <a href="http://www.budget.com.sv/" target="_blank">El Salvador</a> |{' '}
                <a href=" https://www.budget.co.cr/" target="_blank">Costa Rica</a>
              </div>
            </React.Fragment>
          )
        }
      })}
    </nav>
  )
}

export default PostFooter


// WEBPACK FOOTER //
// ./src/menus/PostFooter.js